import { Gender, MaritalStatus } from '@src/generated/graphql';

export const GENDER_OPTIONS: Record<Gender, string> = {
  // t('translation:options.gender.decline_to_answer', 'Decline to answer')
  DECLINE_TO_ANSWER: 'translation:options.gender.decline_to_answer',
  // t('translation:options.gender.female', 'Female')
  FEMALE: 'translation:options.gender.female',
  // t('translation:options.gender.male', 'Male')
  MALE: 'translation:options.gender.male',
  // t('translation:options.gender.other', 'Other')
  OTHER: 'translation:options.gender.other',
};

export const MARITAL_STATUS_OPTIONS: Record<MaritalStatus, string> = {
  // t('translation:options.marital_status.divorced_separated', 'Divorced/Separated')
  DIVORCED_SEPARATED: 'translation:options.marital_status.divorced_separated',
  // t('translation:options.marital_status.domestic_partnership', 'Domestic partnership')
  DOMESTIC_PARTNERSHIP:
    'translation:options.marital_status.domestic_partnership',
  // t('translation:options.marital_status.married', 'Married')
  MARRIED: 'translation:options.marital_status.married',
  // t('translation:options.marital_status.single', 'Single')
  SINGLE: 'translation:options.marital_status.single',
  // t('translation:options.marital_status.widowed', 'Widowed')
  WIDOWED: 'translation:options.marital_status.widowed',
};
